<template>
  <div style="margin-top: 10px;" class="text-center">
    <h2 class="text-center">{{Title}}</h2>
    <div class="row">
      <div class="col-md-12">
        <label>Ciudad</label>
        <KitsBusquedaSimple
          url="City/GetTopByText"
          v-model="City"
          :currentValue="City"
          :cleanButton="true"
          @blur="change"
        />
        <label>Codigo Postal</label>
        <base-input v-model="model.CodPostal" @blur="change" readonly></base-input>
        <label>Calle</label>
        <base-input :readonly="ControlDisabled" v-model="model.Calle" @blur="change"></base-input>
        <label>Altura</label>
        <base-input :readonly="ControlDisabled" v-model="model.Altura" @blur="change"></base-input>
        <label>Piso</label>
        <base-input :readonly="ControlDisabled" v-model="model.Piso" @blur="change"></base-input>
        <label>Dpto</label>
        <base-input :readonly="ControlDisabled" v-model="model.Dpto" @blur="change"></base-input>
      </div>
    </div>
  </div>
</template>

<script>
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";

export default {
  components: { KitsBusquedaSimple },
  props: {
    Title: {
      type: String,
      default: "",
      description: ""
    },
    MissingItemEntityID: {
      type: Number,
      default: 0,
      description: ""
    }
  },
  data() {
    return {
      model: {
        Calle: "",
        Altura: "",
        Piso: "",
        Dpto: "",
        CodPostal: "",
        JSONValue: ""
      },
      City: null,
      Errors: [],
      ControlDisabled: true
    };
  },
  watch: {
    // whenever question changes, this function will run
    City: function(newQuestion, oldQuestion) {
      if (newQuestion != undefined && newQuestion != null)
        this.model.CodPostal = newQuestion.PostalCode;
      this.Errors.push("Debe completar los datos del formulario");
      this.ControlDisabled = false;
      if (newQuestion == undefined || newQuestion == null) {
        this.limpiarCampos();
        this.Errors.push("Debe completar los datos del formulario");
        this.ControlDisabled = true;
      }
    }
  },
  methods: {
    limpiarCampos() {
      let context = this;
      context.model.CodPostal = "";
      context.model.City = "";
      context.model.Altura = "";
      context.model.Calle = "";
      context.model.Piso = "";
      context.model.Dpto = "";
    },
    emitErrors(_context) {
      this.$emit("setErrors", _context.Errors);
    },
    change(element) {
      let _context = this;
      this.validate();

      this.JSONValue = JSON.stringify({
        AddressStreet: _context.model.Calle,
        AddressNumber: _context.model.Altura,
        AddressFloor: _context.model.Piso,
        AddressDpto: _context.model.Dpto,
        AddressCityName: _context.City.Name,
        AddressCityID: _context.City.ID,
        AddressPostalCode: _context.model.CodPostal
      });

      this.$emit("saveValue", {
        MissingItemEntityID: this.MissingItemEntityID,
        JSON: this.JSONValue
      });
    },
    validate() {
      let _context = this;
      _context.Errors = [];

      if (_context.City == null) {
        _context.Errors.push("Debe ingresar la localidad");
      } else if (_context.model.Calle.length == 0) {
        _context.Errors.push("Debe ingresar la calle");
      } else if (_context.model.Altura.length == 0) {
        _context.Errors.push("Debe ingresar la altura");
      }
      _context.emitErrors(_context);
    }
  }
};
</script>